'use client';

import classNames from 'classnames';
import { HTMLAttributes } from 'react';

interface ToggleSwitchProps extends Omit<HTMLAttributes<HTMLDivElement>, 'onChange'> {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  helperText?: string;
  disabled?: boolean;
  required?: boolean;
  toggleSize?: 'toggle-sm' | 'toggle-md' | 'toggle-lg';
  toggleColor?:
    | 'toggle-primary'
    | 'toggle-secondary'
    | 'toggle-accent'
    | 'toggle-success'
    | 'toggle-warning'
    | 'toggle-info'
    | 'toggle-error';
  containerClassName?: string;
  labelClassName?: string;
  helperTextClassName?: string;
}

const ToggleSwitch = ({
  label,
  checked,
  onChange,
  helperText,
  disabled = false,
  required = false,
  toggleSize = 'toggle-md',
  toggleColor = 'toggle-primary',
  containerClassName,
  labelClassName,
  helperTextClassName,
  className,
  ...divProps
}: ToggleSwitchProps) => {
  const handleToggleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked);
  };

  return (
    <div
      className={classNames('grid grid-cols-2 items-center gap-4', containerClassName)}
      {...divProps}>
      <div>
        <label className={classNames('label', labelClassName)}>{label}</label>
        {helperText && (
          <p className={classNames('text-xs text-gray-500', helperTextClassName)}>
            {helperText}
          </p>
        )}
      </div>
      <input
        type="checkbox"
        className={classNames('toggle', toggleSize, toggleColor, className)}
        checked={checked}
        onChange={handleToggleChange}
        disabled={disabled}
        required={required}
      />
    </div>
  );
};

export default ToggleSwitch;
